import { useState } from 'react'
import type { ReadinessAction, ReadinessAnswer, ReadinessQuestion, ReadinessResponse } from './readiness-types'

interface ReadinessQuestionCardProps {
  question: ReadinessQuestion
  answer: ReadinessAnswer | undefined
  action: ReadinessAction | undefined
  canEdit: boolean
  isSaving: boolean
  onSave: (response: ReadinessResponse, evidenceUrl: string, comments: string) => Promise<void>
  onCreateAction: () => void
}

export function ReadinessQuestionCard({ question, answer, action, canEdit, isSaving, onSave, onCreateAction }: ReadinessQuestionCardProps) {
  const [response, setResponse] = useState<ReadinessResponse>(answer?.response ?? 'unanswered')
  const [evidenceUrl, setEvidenceUrl] = useState(answer?.evidence_url ?? '')
  const [comments, setComments] = useState(answer?.comments ?? '')

  return (
    <article className="question-card">
      <div className="question-heading"><h3>{question.prompt}</h3><span className={`response-badge response-${response}`}>{response.replace('_', ' ')}</span></div>
      <p className="question-guidance">{question.guidance}</p>
      <div className="response-options" role="group" aria-label={`Response for ${question.prompt}`}>
        {(['yes', 'no', 'not_applicable'] as ReadinessResponse[]).map((option) => <button className={response === option ? 'selected' : 'secondary-button'} type="button" key={option} disabled={!canEdit || isSaving} onClick={() => setResponse(option)}>{option === 'not_applicable' ? 'N/A' : option.toUpperCase()}</button>)}
      </div>
      <div className="answer-notes">
        <label>Evidence URL<input type="url" value={evidenceUrl} disabled={!canEdit} placeholder="https://…" onChange={(event) => setEvidenceUrl(event.target.value)} /></label>
        <label>Comments<textarea value={comments} disabled={!canEdit} rows={2} maxLength={4000} onChange={(event) => setComments(event.target.value)} /></label>
      </div>
      {response === 'no' && <div className="recommendation"><strong>Recommendation</strong><p>{question.recommendation_text}</p>{!action && canEdit && <button type="button" className="secondary-button" onClick={onCreateAction}>Add to actions</button>}{action && <span className="action-linked">Action {action.status}</span>}</div>}
      {canEdit && <div className="question-actions"><button type="button" disabled={isSaving || response === 'unanswered'} onClick={() => void onSave(response, evidenceUrl, comments)}>{isSaving ? 'Saving…' : 'Save response'}</button></div>}
    </article>
  )
}
